import lightbox from 'lightbox2';



$(document).ready(function () {
    lightbox.option({
        'resizeDuration': 200, 
        'wrapAround': true,
        'disableScrolling': true,
        'albumLabel': $('#offer-gallery').data('gallery-name') + " %1 z %2"
      });

    $('#header-menu .google-auto-placed').remove();

    $('body').css('padding-top', $('#header-menu').height());

    $('#printPost').click(function (event) {
        event.preventDefault();

        window.print();
    });

    $('.widget_nav_menu h3').addClass('button');
    $('.widget_archive h3').addClass('button');
    $('.widget_nav_menu ul').addClass('widget-menu');
    $('.widget_archive ul').addClass('widget-menu');


    $('.widget_nav_menu > .button').on('click', function () {
        $(this).parent().toggleClass('active');
    });
    $('.widget_archive > .button').on('click', function () {
        $(this).parent().toggleClass('active');
    });

    $(window).scroll(function () {
        var $heightScrolled = $(window).scrollTop();
        var $defaultHeight = 15;

        if ($heightScrolled > $defaultHeight) {
            $('.welcome').addClass("fixed-menu")
        } else {
            $('.welcome').removeClass("fixed-menu")
        }
    });

    if ($(".owl-main").length) {
        $(".owl-main").owlCarousel({
            autoplay: false,
            singleItem: true,
            loop: false,
            items: 1,
            mouseDrag: false,
            touchDrag: false,
            autoplayTimeout: 5000,
            autoplaySpeed: 5000,
            animateIn: 'fadeIn', // add this
            animateOut: 'fadeOut' // and this
        });
    }

    $("widget_nav_menu").click(function () {
        $("h3").toggle();
    });

    $('#has_account-1, #has_account-2').on('change', function() {
        if($(this).val() == 1) {
            $('#member-add-offer-form_box9').removeClass('d-none');
            $('#member-add-offer-form_box10').addClass('d-none');
        }

        if($(this).val() == 2) {
            $('#member-add-offer-form_box9').addClass('d-none');
            $('#member-add-offer-form_box10').removeClass('d-none');
        }
    });
});

$('#toggle-social-icons').click(function () {
    $('.social-wrapper').slideToggle('500');
    $(this).toggleClass('open');
});

$('#back-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 1000);
});

$('#search-button').click(function () {
    $('#search-wrapper').slideDown('500');
});

$('#close-search-wrapper').click(function () {
    $('#search-wrapper').slideUp('500');
});

$('.offer-review-stars span').on('click', function() {
    $(this).parent().children('input').val($(this).data('index'));
    $(this).prevAll().addClass('checked');
    $(this).addClass('checked');
    $(this).nextAll().removeClass('checked');
});

// fix thingtun 
jQuery(window).on('load', function () {

    let $ = jQuery;
    let $gt = $('#google_language_translator');

    $gt.find('select').attr('id', 'gtSelector').attr('name', 'google-gt-selector');
    $gt.append('<label for="gtSelector">Wybór języka</label>');

    $('h1.title').remove();
});

//AOS.init();

//<![CDATA
// jQuery(document).ready(function ($) {
//     $('a').each(function () {
//         var a = new RegExp('/' + window.location.host + '/');
//         if (!a.test(this.href) && this.data('lightbox')) {
//             $(this).click(function (event) {
//                 event.preventDefault();
//                 event.stopPropagation();
//                 window.open(this.href, '_blank');
//             });
//         }
//     });
// });
//]]>

const buttonsWithImage = [...document.querySelectorAll('.content p a img')];

buttonsWithImage.forEach((image) => {
    image.parentElement.style.padding = '0';

});

// $(document).on('click', 'a[href^="#"]', function (event) {
//     event.preventDefault();

//     $('html, body').animate({
//         scrollTop: $($.attr(this, 'href')).offset().top - 150
//     }, 500);
// });


$(document).ready(function () {
    var uploaderId = $('.uploader-button').attr('attr-id');
    var uploaderAction = $('.uploader-button').attr('attr-action');
    var uploaderMultiple = $('.uploader-button').attr('attr-multiple');
    var uploaderMultipleSelect = $('.uploader-button').attr('attr-multipleSelect');
    var uploaderAllowedExtensions = $('.uploader-button').attr('attr-allowedExtensions');

    var btn = document.getElementById('uploader-button-' + uploaderId),
        progressBar = document.getElementById('uploader-progress-bar-' + uploaderId),
        progressOuter = document.getElementById('uploader-progress-outer-' + uploaderId),
        msgBox = document.getElementById('uploader-msg-box-' + uploaderId);

    if (btn) {
        var uploader = new ss.SimpleUpload({
            //form_add_attachment
            button: btn,
            url: options.ajax_url + '?action=' + uploaderAction + '&uploaderId=' + uploaderId,
            progressUrl: options.ajax_url + '?action=progressbar',
            responseType: 'json',
            name: uploaderId,
            multiple: uploaderMultiple,
            multipleSelect: uploaderMultipleSelect,
            //            allowedExtensions: uploaderAllowedExtensions.split(', '),
            hoverClass: 'ui-state-hover',
            focusClass: 'ui-state-focus',
            disabledClass: 'ui-state-disabled',
            onSubmit: function (filename, extension) {
                var progress = document.createElement('div'),
                    bar = document.createElement('div'),
                    fileSize = document.createElement('div'),
                    wrapper = document.createElement('div'),
                    progressBox = document.getElementById('uploader-progress-box-' + uploaderId);
                progress.className = 'progress progress-striped';
                bar.className = 'progress-bar progress-bar-success';
                fileSize.className = 'size';
                wrapper.className = 'wrapper';
                progress.appendChild(bar);
                // wrapper.innerHTML = '<div class="name">' + filename + ' | </div>';
                // wrapper.innerHTML = '<div class="name">' + filename + ' | </div>';
                // wrapper.appendChild(fileSize);
                wrapper.appendChild(progress);
                progressBox.appendChild(wrapper);
                this.setProgressBar(bar);
                this.setFileSizeBox(fileSize);
                this.setProgressContainer(wrapper);
            },
            onComplete: function (filename, response) {
                if (!response) {
                    alert(filename + 'upload failed');
                    return;
                }

                var container = $('#uploader-outer-' + uploaderId);
                var item = '';

                if (response.success) {
                    if (response.action == 'form_add_attachment') {
                        if($('#' + uploaderId + '-output').val()) {
                            $('#' + uploaderId + '-output').val($('#' + uploaderId + '-output').val().slice(0, -1) + ',' + '["' + response.upload_url + response.file.name + '","' + response.file.name + '"]]');
                        }
                        else {
                            $('#' + uploaderId + '-output').val('[["' + response.upload_url + response.file.name + '","' + response.file.name + '"]]');
                        }
                        console.log($('#' + uploaderId + '-output').val());
                        var type = '';

                        switch (response.file.type) {
                            case 'word':
                                type = '<i class="fas fa-file-word"></i>';
                                break;
                            case 'excel':
                                type = '<i class="fas fa-file-excel"></i>';
                                break;
                            case 'pdf':
                                type = '<i class="fas fa-file-pdf"></i>';
                                break;
                            case 'image/png':
                            case 'image/jpg':
                            case 'image/jpeg':
                                type = '<i class="fas fa-file-image"></i>';
                                break;
                            default:
                                type = '<i class="far fa-file"></i>';
                        }

                        item = '<li class="attachment" data-image="' + response.upload_url + response.file.name + '" data-alt="' + response.file.name + '">'
                            + '<div class="attachment-image-wrapper"><img src="' + response.upload_url + response.file.name + '" /></div>' 
                            + '<label>Opis zdjęcia</label><input type="text" value="' + response.file.name + '" />'
                            + '<span class="delete-image">x</span></li>';
                    }

                    if (response.action == 'upload_single_image') {
                        $('#' + uploaderId + '-output').val(response.file.name);

                        container.html('');
                        item = '<li class="image" attr-id="' + response.file.id + '">'
                            + '<img src="' + response.upload_url + response.file.name + '" />'
                            + '</li>';
                    }
                } else {
                    item = '<li class="error">' + response.error_text + '</li>';
                }

                container.append(item);
            },
            onError: function () {

                msgBox.innerHTML = 'Nie można dołączyć pliku.';
            }
        });
    }
});



$('#filter_form input').on('change', function () {
    var isButtonsActive = false;

    $('#filter_form input').each(function () {
        if ($(this).attr('type') == 'number' && $(this).val()) {
            isButtonsActive = true;
        }
        
        if ($(this).attr('type') == 'checkbox' && $(this).is(':checked')) {
            isButtonsActive = true;
        }

        if ($(this).attr('type') == 'time' && $(this).val()) {
            isButtonsActive = true;
        }
    })

    if (isButtonsActive) {
        $('#filter_buttons').show(); 
    }
    else {
        $('#filter_buttons').hide();
    }
});

$('#filter_form select').on('change', function () {
    var isButtonsActive = false;

    $('#filter_form select').each(function () {
        if($(this).val()) {
            isButtonsActive = true;
        }
    });

    if (isButtonsActive) {
        $('#filter_buttons').show();
    }
    else {
        $('#filter_buttons').hide();
    }
});

$('#accept_filters').on('click', function (event) {
    event.preventDefault();

    $('#filter_form').submit();
});

$('#remove_filters').on('click', function (event) {
    event.preventDefault();

    $('#filter_form input').each(function () {
        if ($(this).attr('type') == 'number') {
            $(this).val(null);
        }

        if ($(this).attr('type') == 'checkbox') {
            $(this).prop('checked', false);
        }
    });

    $('#filter_form select').each(function () {
        $(this).val(null);
    });

    $('#filter_buttons').hide();
    $('#filter_form').submit();
});